import { LitElement, html, css, unsafeCSS } from 'lit';
import { RDPropsetContainer } from '../Container/PropContainer.js';

import styles from './Range.css?raw';

export class propRange extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    value: { type: String },
    disabled: { type: Boolean, reflect: true },
    step: { type: Number, reflect: true },
    min: { type: Number, reflect: true },
    max: { type: Number, reflect: true },
    showBubbles: { type: Boolean, reflect: true },
    prefix: { type: String },
    suffix: { type: String },
    decimalPlaces: { type: Number },
    onInput: { type: Function },
    onChange: { type: Function },
    callback: { type: Function },
  };
  constructor() {
    super();
    this.value = 50;
    this.disabled = false;
    this.step = 1;
    this.min = 0;
    this.max = 100;
    this.showBubbles = true;
    this.prefix = '';
    this.suffix = '';
    this.decimalPlaces = 1;
    this.onInput = null;
    this.onChange = null;
    this.callback = null;
  }
  firstUpdated() {
    let input = this.renderRoot.querySelector('input[type="range"]');
    if (input) {
      input.value = this.value;
    }
  }
  _onInput(e) {
    this.value = e.target.value;
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)(this.value || 0);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || 0);
    }
    this.dispatchEvent(new CustomEvent('prop-value-input', { detail: { value: this.value || 0 } }));
  }
  _onChange(e) {
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange.bind(this)(this.value || 0);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || 0);
    }
    this.value = e.target.value;
    this.dispatchEvent(new CustomEvent('prop-value-changed', { detail: { value: this.value || 0 } }));
  }

  renderBody() {
    return html`
      <div class="range-input-container">
        ${this.showBubbles ? html` <div class="bubble">${this.prefix}${this.value}${this.suffix}</div> ` : ''}
        <input type="range" .value="${this.value}" ?disabled="${this.disabled}" .min="${this.min}" .max="${this.max}" .step="${this.step}" @input="${this._onInput}" @change="${this._onChange}" />
      </div>
    `;
  }
}

if (!customElements.get('rd-prop-range')) {
  customElements.define('rd-prop-range', propRange);
}
